<div class="filter-date">
  <div class="filter-date__input-group vox-input-group vox-input-group_dense">
    <ngb-datepicker
      [ngModel]="_date"
      [startDate]="_date"
      (dateSelect)="onDateSelect($event)"
      [maxDate]="maxDate"
      [minDate]="minDate">
    </ngb-datepicker>
  </div>
</div>
